/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Replace_NextInputs */

const en_dialog_text_to_audio_replace_next = /** @type {(inputs: Dialog_Text_To_Audio_Replace_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace`)
};

const es_dialog_text_to_audio_replace_next = /** @type {(inputs: Dialog_Text_To_Audio_Replace_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reemplazar`)
};

/**
* | output |
* | --- |
* | "Replace" |
*
* @param {Dialog_Text_To_Audio_Replace_NextInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_replace_next = /** @type {((inputs?: Dialog_Text_To_Audio_Replace_NextInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Replace_NextInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_replace_next(inputs)
	return en_dialog_text_to_audio_replace_next(inputs)
});